import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            资讯分类导航
          </h2>
          <span className="text-xs text-foreground-400 mt-1">123导航分类</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}